import * as React from 'react';
import { SvgIcon } from '../../icons/SvgIcon';

interface IProps {
	className?: string;
}

export const CSMAccountsIcon: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`csm-accounts-icon ${className || ''}`} height={689} width={689}>
			<g fill='none' fillRule='evenodd'>
				<mask id='csm-accounts-icon-mask' fill='#fff'>
					<circle cx='344.5' cy='344.5' r='344.5' />
				</mask>
				<circle fill='#FFF0A2' cx='344.5' cy='344.5' r='344.5' />
				<g mask='url(#csm-accounts-icon-mask)' fillRule='nonzero'>
					<g transform='translate(92 220)'>
						<ellipse fill='#F3CE0D' cx='418.5' cy='345.5' rx='157.5' ry='7.5' />
						<path
							d='m418 193.2 11.893 46.186s.44 32.55 3.083 45.307c2.643 12.756 11.453 43.548 11.453 43.548L455 330l-2.202-43.108s0-25.952-2.203-31.67c-2.202-5.719-6.607-64.222-6.607-64.222L418 193.2Z'
							fill='#FFB8B8'
						/>
						<path
							d='m418 193.2 11.893 46.186s.44 32.55 3.083 45.307c2.643 12.756 11.453 43.548 11.453 43.548L455 330l-2.202-43.108s0-25.952-2.203-31.67c-2.202-5.719-6.607-64.222-6.607-64.222L418 193.2Z'
							fill='#000'
							opacity='.1'
						/>
						<path
							d='M450.503 0C435.865 0 424 13.155 424 29.383V50h6.347l3.675-7.639-.919 7.639h40.798l3.34-6.944-.834 6.944H481V33.812C481 15.138 467.346 0 450.503 0Z'
							fill='#2F2E41'
						/>
						<path d='M406.872 186s-5.2 22.65 1.734 24.87c6.935 2.221 5.201-24.87 5.201-24.87h-6.935Z' fill='#FFB8B8' />
						<path fill='#3F3D56' d='m415.4 72-3.467 3.963.867 76.171-7.8 36.105L422.334 190 431 117.35l-2.6-36.984z' />
						<path
							fill='#000'
							opacity='.1'
							d='m415.4 72-3.467 3.963.867 76.171-7.8 36.105L422.334 190 431 117.35l-2.6-36.984z'
						/>
						<circle fill='#FFB8B8' cx='449' cy='28' r='19' />
						<path
							d='M438 39.544s5.593 28.78 3.05 31.808C438.509 74.382 468 65.8 468 65.8S458.339 46.108 463.424 35L438 39.544ZM485.128 165s5.2 22.65-1.734 24.87c-6.935 2.221-5.201-24.87-5.201-24.87h6.935ZM444.531 188s-7.465 44.824-7.026 51.415c.44 6.592 0 7.47 0 7.47s-7.465 19.336-9.66 30.323c-2.196 10.986-7.026 25.048-7.026 25.048S415.11 315 419.94 315c4.83 0 11.417-1.758 11.417-1.758a22.453 22.453 0 0 1 4.83-13.99c5.27-6.664 21.078-37.864 21.078-41.82 0-3.955 2.634-15.38 2.634-15.38l10.1-48.779L444.531 188Z'
							fill='#FFB8B8'
						/>
						<path
							d='M413.623 157.644s-7.525 37.82-.886 38.7c6.64.88 15.934-5.717 27.884 1.759 11.95 7.476 31.868 5.717 31.868 5.717s13.72-34.742 1.327-43.098c-12.392-8.355-60.193-3.078-60.193-3.078ZM422.372 309.012a11.225 11.225 0 0 1 6.03-.882 7.718 7.718 0 0 0 5.598-1.324s-3.445 12.794-3.015 17.648c.431 4.853-1.292 25.588-10.336 23.382-9.044-2.206-11.628-8.823-8.182-20.294 3.445-11.471 2.584-24.707 2.584-24.707s6.285-6.65 7.449-5.751c1.164.898-.128 11.928-.128 11.928Z'
							fill='#2F2E41'
						/>
						<path
							d='M451.157 325.559s-4.322-9.645-9.51-.877c-5.186 8.768-5.618 10.96-5.618 10.96s-14.696 13.59-4.323 14.905c10.374 1.315 18.587-.438 18.587-2.63 0-2.192 5.187-1.754 5.619-3.508.432-1.753-.865-17.974-.865-17.974l-3.89-.876Z'
							fill='#2F2E41'
						/>
						<path
							d='M461.561 54.122s-18.551 3.518-20.76 3.078c-.497-.087-1-.14-1.505-.159a22.403 22.403 0 0 0-12.33 3.044c-6.15 3.556-15.316 9.886-15.316 16.021 0 9.234 11.925 25.062 11.925 25.062s-11.042 37.813-10.159 41.33c.884 3.518-6.625 15.39-1.766 19.347 4.858 3.957 51.236 0 59.628 3.957 8.393 3.957 4.417-52.762 4.417-52.762s22.527-51.443 11.043-56.28a148.992 148.992 0 0 0-9.562-3.664 20.297 20.297 0 0 0-15.615 1.026Z'
							fill='#3F3D56'
						/>
						<path
							d='m478.512 57 10.074 1.673S493 63.176 493 65.38c0 2.206-.878 97.485-2.195 100.573-1.317 3.087-15.805 1.764-15.805 1.764l2.634-54.256.878-56.462Z'
							fill='#3F3D56'
						/>
						<path
							d='M458.427 7.65c-2.565-3.504-6.589-5.593-10.884-5.65h-.516C437.071 2 429 11.165 429 22.47h3.336l.539-4.171.79 4.172h19.785l1.658-3.53-.414 3.53h3.892c1.816 9.176-.793 18.353-7.83 27.529h6.631l3.316-7.059-.83 7.059h12.64L475 33.765c0-12.16-6.944-22.47-16.573-26.115Z'
							fill='#2F2E41'
						/>
						<path fillOpacity='.5' fill='#3F3D56' d='M11 13h338v217H11z' />
						<path fillOpacity='.5' fill='#3F3D56' d='M0 1h338v217H0z' />
						<path fill='#3F3D56' d='M23 25h338v217H23z' />
						<path fill='#C75DA6' d='M200 64h152v177H200z' />
						<path
							fill='#FFF'
							d='M251 81h92v4h-92zM251 89h92v4h-92zM251 97h31v4h-31zM62 161h92v4H62zM62 169h92v4H62zM61 177h31v4H61zM230 126h92v4h-92zM230 134h92v4h-92zM230 142h92v4h-92zM230 151h92v4h-92zM230 159h92v4h-92zM230 167h92v4h-92zM230 175h92v4h-92zM230 183h92v4h-92zM230 191h92v4h-92zM230 199h92v4h-92zM230 207h92v4h-92z'
						/>
						<path
							d='M141 101.5a33.417 33.417 0 0 1-12.435 26.044 33.032 33.032 0 0 1-4.584 3.124 32.39 32.39 0 0 1-3 1.504 33.176 33.176 0 0 1-10.727 2.716c-.91.076-1.829.113-2.757.112a33.113 33.113 0 0 1-5.481-.45c-.639-.1-1.269-.224-1.891-.368a32.23 32.23 0 0 1-3.22-.893 33.426 33.426 0 0 1-11.757-6.838 30.492 30.492 0 0 1-2.493-2.48c-10.031-11.091-11.496-27.486-3.59-40.18C86.97 71.1 102.33 65.184 116.708 69.294 131.088 73.404 141 86.546 141 101.5Z'
							fill='#C75DA6'
						/>
						<path
							d='M361 120c-31.053 0-56.226 25.238-56.226 56.37 0 9.117-7.373 16.508-16.467 16.508h-27.31a48.934 48.934 0 0 0-34.646 14.387A49.186 49.186 0 0 0 212 242h149V120Z'
							fill='#3F3D56'
						/>
						<path fill='#2F2E41' d='M189 25h7v217h-7z' />
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
